export const TrophiesStickSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='825.482'
      height='820.904'
      viewBox='0 0 825.482 820.904'
    >
      <defs>
        <filter
          id='shadow'
          x='0'
          y='670.904'
          width='356'
          height='132'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dx='6' dy='12' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='6' result='blur' />
          <feFlood floodOpacity='0.329' />
          <feComposite operator='in' in2='blur' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <g
        id='Awards_Button_-_Main'
        data-name='Awards Button - Main'
        transform='translate(1.261 1.065)'
      >
        <g transform='matrix(1, 0, 0, 1, -1.26, -1.07)' filter='url(#shadow)'>
          <path
            id='shadow-2'
            data-name='shadow'
            d='M10,0H310a10,10,0,0,1,10,10V86a10,10,0,0,1-10,10H10A10,10,0,0,1,0,86V10A10,10,0,0,1,10,0Z'
            transform='translate(12 676.9)'
            fill='#fff'
          />
        </g>
        <g id='shape'>
          <g id='Group_46' data-name='Group 46' transform='translate(0 3.839)'>
            <g
              id='Layer_2'
              data-name='Layer 2'
              transform='translate(0 671.021)'
            >
              <g id='logos'>
                <path
                  id='Path_4'
                  data-name='Path 4'
                  d='M333.733,409.289a12.685,12.685,0,0,0,7.425-2.678c.243-.175.482-.359.955-.752.166-.136.33-.277.72-.635,3.777-3.407,6.723-10.266,5.363-18.423l-11.282-61.382c-1.354-8.917-7.311-15.367-14.216-15.389H25.566c-6.77.238-12.659,6.6-14.1,15.389L.316,386.8c-2.076,12.856,6.476,22.553,14.419,22.488h319'
                  transform='translate(0 -310.03)'
                  fill='#002f6c'
                  stroke='#000'
                  strokeWidth='2'
                />
              </g>
            </g>
            <path
              id='Path_5'
              data-name='Path 5'
              d='M141.425,671.022A41.62,41.62,0,0,0,159.4,666.1c7.3-3.887,17.39-11.316,29.063-25.053l23.2-34.5,38.88-59.564,25.791-38.612L313.086,449l27.777-44.262,39.849-60.3,47.566-73.589,45.13-69.563L515,136.356l53.592-82.571L598.869,8.03s11.34-22.736,35.144-5.27c12.039,8.573,6.323,21.842,3.938,26.784-4.062,8.16-48.74,78.481-48.74,78.481l-29.6,45.257-30.35,48.244-33.08,51.015-30.553,47.487-23.806,38.418-40.233,63.633-58.669,88.74L310.175,541.94,279.8,589.556l-41.564,64.2L207.866,700.5l-30.593,44.223-6.337,8.623-8.1,11.024'
              transform='translate(181.737 0)'
              fill='#002f6c'
              stroke='#000'
              strokeWidth='2'
            />
          </g>
        </g>
        <text
          id='Text'
          transform='translate(21.477 692.839)'
          fill='#fff'
          stroke='#000'
          strokeWidth='2'
          fontSize='48'
          fontWeight='700'
        >
          <tspan x='8.008' y='47'>
            Trophies
          </tspan>
        </text>
        <g id='trophy-svgrepo-com' transform='translate(163.206 684.84)'>
          <path
            id='Path_69'
            data-name='Path 69'
            d='M85.367,60.138A19.547,19.547,0,0,1,66.025,43.75l-.045-.264a3.445,3.445,0,0,1,.766-2.84,3.389,3.389,0,0,1,2.593-1.2h8.307V35.31H69.34a7.521,7.521,0,0,0-5.75,2.662,7.626,7.626,0,0,0-1.69,6.2l.045.263A23.67,23.67,0,0,0,85.367,64.275h0V60.137Z'
            transform='translate(0 -29.794)'
            fill='#ebb45f'
          />
          <g
            id='Group_29'
            data-name='Group 29'
            transform='translate(88.001 5.516)'
          >
            <path
              id='Path_70'
              data-name='Path 70'
              d='M321.1,37.972a7.521,7.521,0,0,0-5.75-2.662H307.04v4.138h8.307a3.388,3.388,0,0,1,2.593,1.2,3.445,3.445,0,0,1,.766,2.84l-.045.264A19.547,19.547,0,0,1,299.32,60.137h0v4.138h0a23.67,23.67,0,0,0,23.423-19.844l.045-.263A7.626,7.626,0,0,0,321.1,37.972Z'
              transform='translate(-288.411 -35.31)'
              fill='#ffc36e'
            />
            <path
              id='Path_71'
              data-name='Path 71'
              d='M237.794,258.483h-8.276l1.379-28.966h5.517Z'
              transform='translate(-229.518 -199.172)'
              fill='#ffc36e'
            />
          </g>
          <path
            id='Path_72'
            data-name='Path 72'
            d='M230.9,229.517l-1.379,28.966h4.138V229.517Z'
            transform='translate(-141.517 -193.656)'
            fill='#ebb45f'
          />
          <path
            id='Path_73'
            data-name='Path 73'
            d='M219.587,412.966H203.035v-5.517a1.38,1.38,0,0,1,1.379-1.379h13.793a1.379,1.379,0,0,1,1.379,1.379v5.517Z'
            transform='translate(-119.172 -342.622)'
            fill='#ffd782'
          />
          <path
            id='Path_74'
            data-name='Path 74'
            d='M211.31,406.069h-6.9a1.38,1.38,0,0,0-1.379,1.379v5.517h6.9v-5.517A1.38,1.38,0,0,1,211.31,406.069Z'
            transform='translate(-119.172 -342.622)'
            fill='#ffc36e'
          />
          <path
            id='Path_75'
            data-name='Path 75'
            d='M195.31,445.517H167.724l1.94-2.91a2.759,2.759,0,0,1,2.3-1.228h19.116a2.759,2.759,0,0,1,2.3,1.228Z'
            transform='translate(-89.379 -372.414)'
            fill='#fff'
          />
          <path
            id='Path_76'
            data-name='Path 76'
            d='M180.235,441.379h-8.276a2.759,2.759,0,0,0-2.3,1.228l-1.94,2.91H176l1.94-2.91A2.759,2.759,0,0,1,180.235,441.379Z'
            transform='translate(-89.379 -372.414)'
            fill='#fff'
          />
          <path
            id='Path_77'
            data-name='Path 77'
            d='M187.862,467.31H160.275a1.379,1.379,0,0,1-1.379-1.379v-5.517a1.379,1.379,0,0,1,1.379-1.379h27.586a1.379,1.379,0,0,1,1.379,1.379v5.517A1.379,1.379,0,0,1,187.862,467.31Z'
            transform='translate(-81.93 -387.311)'
            fill='#fff'
          />
          <path
            id='Path_78'
            data-name='Path 78'
            d='M168.552,465.931v-5.517a1.379,1.379,0,0,1,1.379-1.379h-9.655a1.379,1.379,0,0,0-1.379,1.379v5.517a1.379,1.379,0,0,0,1.379,1.379h9.655A1.379,1.379,0,0,1,168.552,465.931Z'
            transform='translate(-81.931 -387.311)'
            fill='#fff'
          />
          <path
            id='Path_79'
            data-name='Path 79'
            d='M162.715,39.36l-6.105,4.748a2.759,2.759,0,0,1-1.694.581h-6.383a2.759,2.759,0,0,1-1.694-.581l-6.105-4.748a16.551,16.551,0,0,1-6.3-11.332l-2.021-19.2h38.621l-2.021,19.2A16.551,16.551,0,0,1,162.715,39.36Z'
            transform='translate(-59.586 -7.449)'
            fill='#ffd782'
          />
          <path
            id='Path_80'
            data-name='Path 80'
            d='M151.525,44.109l-2.835-4.748a25.345,25.345,0,0,1-2.925-11.333l-.938-19.2H132.414l2.021,19.2a16.553,16.553,0,0,0,6.3,11.333l6.105,4.748a2.758,2.758,0,0,0,1.694.581h3.779A.991.991,0,0,1,151.525,44.109Z'
            transform='translate(-59.586 -7.449)'
            fill='#ffc36e'
          />
          <g
            id='Group_30'
            data-name='Group 30'
            transform='translate(71.449 -0.001)'
          >
            <path
              id='Path_81'
              data-name='Path 81'
              d='M163.586,2.758H124.965a1.379,1.379,0,0,1-1.379-1.379h0A1.379,1.379,0,0,1,124.965,0h38.621a1.379,1.379,0,0,1,1.379,1.379h0A1.379,1.379,0,0,1,163.586,2.758Z'
              transform='translate(-123.586 0.001)'
              fill='#ffd782'
            />
            <path
              id='Path_82'
              data-name='Path 82'
              d='M230.344,277.792h-8.276a1.38,1.38,0,0,1-1.379-1.379v-1.379a1.379,1.379,0,0,1,1.379-1.379h8.276a1.379,1.379,0,0,1,1.379,1.379v1.379A1.38,1.38,0,0,1,230.344,277.792Z'
              transform='translate(-205.517 -230.895)'
              fill='#ffd782'
            />
          </g>
          <g
            id='Group_31'
            data-name='Group 31'
            transform='translate(72.973 2.758)'
          >
            <path
              id='Path_83'
              data-name='Path 83'
              d='M224.828,276.413v-1.379a1.379,1.379,0,0,1,1.379-1.379h-4.138a1.379,1.379,0,0,0-1.379,1.379v1.379a1.38,1.38,0,0,0,1.379,1.379h4.138A1.379,1.379,0,0,1,224.828,276.413Z'
              transform='translate(-207.042 -233.654)'
              fill='#ffc36e'
            />
            <path
              id='Path_84'
              data-name='Path 84'
              d='M171.383,20.414l.29-2.759h-38.33l.29,2.759Z'
              transform='translate(-133.343 -17.655)'
              fill='#ffc36e'
            />
          </g>
          <path
            id='Path_85'
            data-name='Path 85'
            d='M145.679,17.655H133.343l.29,2.759h12.181Z'
            transform='translate(-60.37 -14.897)'
            fill='#ebb45f'
          />
          <path
            id='Path_86'
            data-name='Path 86'
            d='M136,1.379A1.379,1.379,0,0,1,137.38,0H124.966a1.379,1.379,0,0,0,0,2.759H137.38A1.379,1.379,0,0,1,136,1.379Z'
            transform='translate(-52.138 -0.001)'
            fill='#ffc36e'
          />
          <g
            id='Group_32'
            data-name='Group 32'
            transform='translate(96.277 2.713)'
          >
            <path
              id='Path_87'
              data-name='Path 87'
              d='M314.561,21.632a5.525,5.525,0,0,1-4.148-4.148.14.14,0,0,0-.276,0,5.525,5.525,0,0,1-4.148,4.148.14.14,0,0,0,0,.276,5.525,5.525,0,0,1,4.148,4.148.14.14,0,0,0,.276,0,5.525,5.525,0,0,1,4.148-4.148A.14.14,0,0,0,314.561,21.632Z'
              transform='translate(-302.219 -17.368)'
              fill='#fff'
            />
            <path
              id='Path_88'
              data-name='Path 88'
              d='M288.79,67.961A4.145,4.145,0,0,1,285.824,65a.134.134,0,0,0-.264,0,4.145,4.145,0,0,1-2.965,2.965.134.134,0,0,0,0,.264,4.145,4.145,0,0,1,2.965,2.965.134.134,0,0,0,.264,0,4.145,4.145,0,0,1,2.965-2.965A.134.134,0,0,0,288.79,67.961Z'
              transform='translate(-282.486 -57.462)'
              fill='#fff'
            />
          </g>
        </g>
        <g id='g10' transform='translate(242.512 800.134)'>
          <g id='g12' transform='translate(0 -43.847)'>
            <path
              id='path14'
              d='M24.577-38.3a1.064,1.064,0,0,0,1.064-1.257l-.824-3.436a1.069,1.069,0,0,0-1.046-.859H1.883a1.092,1.092,0,0,0-1.044.859L.023-39.552A1.069,1.069,0,0,0,1.086-38.3H24.577'
              transform='translate(0 43.847)'
              fill='#213366'
            />
            <path
              id='path16'
              d='M29.656-30.862a.549.549,0,0,0,.539-.4l.589-1.406h.087l.88,2.074c.065.145.14.366.337.359l.01.085h-.94v-.084c.344-.021.284-.124.166-.406l-.126-.3h-.941a2.925,2.925,0,0,0-.193.559c0,.135.161.149.247.151v.085h-.731v-.084a.342.342,0,0,0,.261-.2,3.076,3.076,0,0,0,.2-.428.676.676,0,0,1-.546.269.754.754,0,0,1-.684-.836.82.82,0,0,1,.819-.908c.207,0,.533.112.55.371A.174.174,0,0,1,30-31.79a.18.18,0,0,1-.173-.168c0-.143-.081-.246-.269-.248-.306,0-.457.331-.459.635,0,.339.188.717.556.709Zm1.481-.249-.406-.99-.4.99Zm-8.492.424c.169-.016.219-.078.216-.233v-.9c.013-.2-.035-.234-.225-.233v-.083l.55-.2v.255c0,.032.007.033.031.012a.8.8,0,0,1,.083-.08.741.741,0,0,1,.448-.182.394.394,0,0,1,.372.308.83.83,0,0,1,.559-.308c.441,0,.466.384.466.712v.7c0,.168.062.218.226.235v.07H24.6v-.07c.162-.017.225-.067.225-.235v-.757c0-.35-.054-.438-.277-.438a.429.429,0,0,0-.374.22v.974c0,.169.062.218.225.235v.07h-.784v-.07c.166-.017.23-.064.233-.235v-.772c0-.191-.016-.423-.247-.423a.542.542,0,0,0-.412.212v.983c0,.17.068.218.234.235v.07h-.784v-.07Zm3.462-1.642a.64.64,0,0,1,.647.691H25.627c.008.349.18.791.577.792a.694.694,0,0,0,.55-.395l.077.019a.862.862,0,0,1-.771.636.759.759,0,0,1-.7-.836C25.361-31.947,25.653-32.33,26.106-32.329Zm-.076.147c-.244,0-.356.181-.388.4h.724C26.354-31.985,26.257-32.184,26.03-32.182Zm-4.213-.024c-.26-.02-.418.215-.448.537-.045.518.093.931.427.961.273.024.428-.265.456-.584C22.282-31.628,22.22-32.168,21.818-32.206ZM21-32.657h.089l.024.749a.733.733,0,0,1,.689-.422.785.785,0,0,1,.819.819.853.853,0,0,1-.819.926.807.807,0,0,1-.79-.851c-.005-.573-.172-1.029-.787-1.059-.561-.028-.826.486-.824,1.15,0,.515.261,1.066.846,1.067a.987.987,0,0,0,.8-.351l.07.089a1.155,1.155,0,0,1-.9.448,1.2,1.2,0,0,1-1.254-1.281,1.221,1.221,0,0,1,1.247-1.288,1.185,1.185,0,0,1,.319.043c.088.023.162.052.222.072.131.04.192.033.249-.109Zm7.023,1.969c.217-.016.267-.079.27-.233v-.9c.008-.248-.109-.228-.279-.135a.18.18,0,0,1-.135.015.12.12,0,0,1-.081-.051l-.019-.025a.167.167,0,0,0-.14-.069c-.068,0-.217.179-.216.28v.886c0,.191.093.221.27.234v.07h-.866v-.07c.219-.017.269-.081.27-.234v-.811c0-.26.008-.4-.27-.321v-.079l.6-.2v.314c.078-.127.229-.31.4-.309a.229.229,0,0,1,.242.183l.54-.219.007,1.445c0,.191.094.221.272.234v.07h-.874v-.07Zm4.94-.073c.033-.027.052-.1.052-.208v-1.367c0-.112-.019-.18-.054-.208a.5.5,0,0,0-.246-.056v-.074H33.6a1.258,1.258,0,0,1,.6.12.433.433,0,0,1,.225.415.391.391,0,0,1-.156.337.715.715,0,0,1-.227.1.946.946,0,0,1,.333.162.4.4,0,0,1,.157.339.5.5,0,0,1-.345.5,1.212,1.212,0,0,1-.442.07H32.711V-30.7A.543.543,0,0,0,32.959-30.761Zm1.122-1.37a.354.354,0,0,0-.221-.361,1.062,1.062,0,0,0-.379-.052.246.246,0,0,0-.115.015c-.01.007-.017.031-.017.081v.686l.285-.006a.649.649,0,0,0,.257-.049A.314.314,0,0,0,34.081-32.131Zm.068.939a.344.344,0,0,0-.183-.341,1.061,1.061,0,0,0-.479-.094h-.139v.753c0,.049.013.081.039.092a.587.587,0,0,0,.209.022.792.792,0,0,0,.4-.09A.352.352,0,0,0,34.15-31.191Zm1.774.168a.559.559,0,0,0,.012.141c.015.053.045.077.088.077a.13.13,0,0,0,.064-.013A.678.678,0,0,0,36.2-30.9v.132a.635.635,0,0,1-.13.117.382.382,0,0,1-.214.069.211.211,0,0,1-.189-.087.368.368,0,0,1-.062-.18,1.619,1.619,0,0,1-.221.167.622.622,0,0,1-.315.1.385.385,0,0,1-.278-.113.382.382,0,0,1-.117-.286.527.527,0,0,1,.266-.446,3.957,3.957,0,0,1,.658-.294v-.146a.626.626,0,0,0-.035-.252.253.253,0,0,0-.249-.116.339.339,0,0,0-.171.046.138.138,0,0,0-.078.126c0,.047.014.093.014.14a.162.162,0,0,1-.072.151.173.173,0,0,1-.094.024.159.159,0,0,1-.133-.057.189.189,0,0,1-.045-.124.38.38,0,0,1,.163-.273.691.691,0,0,1,.47-.14.513.513,0,0,1,.491.232.781.781,0,0,1,.07.368v.724m-.656-.445a.438.438,0,0,0-.251.357.27.27,0,0,0,.1.235.241.241,0,0,0,.15.048.41.41,0,0,0,.22-.065.187.187,0,0,0,.1-.161v-.561A1.578,1.578,0,0,0,35.268-31.468Zm1.1.721a.29.29,0,0,0,.048-.2v-.921a.42.42,0,0,0-.02-.157.131.131,0,0,0-.131-.063.151.151,0,0,0-.031,0l-.054.006v-.085c.116-.033.241-.074.353-.11l.17-.054c.012,0,.022,0,.025.015a.072.072,0,0,1,0,.026v.232a1.89,1.89,0,0,1,.248-.194.571.571,0,0,1,.3-.086.4.4,0,0,1,.232.071.567.567,0,0,1,.2.5v.847a.263.263,0,0,0,.049.179.279.279,0,0,0,.191.054.508.508,0,0,0,.234-.054.245.245,0,0,0,.052-.188v-1.459c0-.086-.015-.136-.039-.156a.193.193,0,0,0-.12-.033c-.044,0-.087,0-.129.007v-.069l.174-.045c.125-.032.232-.063.32-.092a.559.559,0,0,1,.1-.027c.016,0,.024,0,.028.02v1.158l.474-.427a.427.427,0,0,0,.07-.076.081.081,0,0,0,.017-.044.038.038,0,0,0-.032-.042.848.848,0,0,0-.153-.016V-32.3h.774v.072a.75.75,0,0,0-.327.081,3.4,3.4,0,0,0-.465.4l-.09.082.315.422a3.1,3.1,0,0,0,.386.443.468.468,0,0,0,.279.12v.072h-.826v-.072l.072,0a.161.161,0,0,0,.054-.012.028.028,0,0,0,.017-.029.123.123,0,0,0-.03-.072l-.533-.713v.644a.156.156,0,0,0,.086.159.552.552,0,0,0,.194.026v.072h-1.7v-.072a.321.321,0,0,0,.187-.069.361.361,0,0,0,.049-.23v-.78a.517.517,0,0,0-.057-.256.218.218,0,0,0-.208-.1.388.388,0,0,0-.214.072,1.1,1.1,0,0,0-.157.133V-30.9a.2.2,0,0,0,.055.166.331.331,0,0,0,.188.044v.072h-.8v-.072a.335.335,0,0,0,.181-.06'
              transform='translate(-16.555 34.204)'
              fill='#fff'
            />
            <path
              id='path18'
              d='M26.881-36.419a.732.732,0,0,0,.736-.9l-.789-3.416a.781.781,0,0,0-.753-.6H4.187a.764.764,0,0,0-.735.6l-.788,3.416a.733.733,0,0,0,.726.9Zm0-.266a.509.509,0,0,0,.479-.549l-.823-3.409a.45.45,0,0,0-.461-.408H4.187a.472.472,0,0,0-.461.408l-.814,3.409a.512.512,0,0,0,.479.549H26.881'
              transform='translate(-2.304 41.654)'
              fill='#fff'
              fillRule='evenodd'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
